import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isArray } from 'rxjs/internal-compatibility';

@Component({
    selector: 'app-checkbox-group',
    templateUrl: './checkbox-group.component.html',
    styleUrls: ['./checkbox-group.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CheckboxGroupComponent,
            multi: true,
        },
    ],
})
export class CheckboxGroupComponent implements ControlValueAccessor {
    @Input() public multipleSelection = true;

    private itemModel: any;
    private onChange: (m: any) => void;
    private onTouched: (m: any) => void;

    public get model(): any {
        return this.itemModel;
    }
    public writeValue(value: any): void {
        if (isArray(value)) {
            this.itemModel = [...value];
        } else {
            this.itemModel = value;
        }
    }
    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public set(value: any): void {
        this.itemModel = value;
        this.onChange(this.itemModel);
    }

    public addOrRemove(value: any): void {
        if (this.contains(value)) {
            this.remove(value);
        } else {
            this.add(value);
        }
    }

    public contains(value: any): boolean {
        if (isArray(this.itemModel)) {
            return this.itemModel.indexOf(value) > -1;
        } else if (this.itemModel) {
            return this.itemModel === value;
        }
        return false;
    }

    private add(value: any): void {
        if (!this.contains(value)) {
            if (this.multipleSelection) {
                this.itemModel = [...this.itemModel, value];
            } else {
                this.itemModel = [value];
            }
            this.onChange(this.itemModel);
        }
    }

    private remove(value: any): void {
        const index: number = this.itemModel.indexOf(value);
        if (!this.itemModel || index < 0) {
            return;
        }
        this.itemModel.splice(index, 1);
        this.onChange(this.itemModel);
    }
}
